import { colorTokenFromNestedArguments } from '@klarna/designtokens'; // eslint-disable-next-line max-params

export function buildInteractiveColor(colDefault, colHovered, colPressed, colDisabled, tokenOptions) {
  return colorTokenFromNestedArguments({
    default: colDefault,
    hovered: colHovered,
    pressed: colPressed,
    disabled: colDisabled
  }, ['interactiveState'], tokenOptions);
}
//# sourceMappingURL=utils.js.map